import { render, staticRenderFns } from "./DiagramNodeTitle.vue?vue&type=template&id=51477eda&"
import script from "./DiagramNodeTitle.vue?vue&type=script&lang=js&"
export * from "./DiagramNodeTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/max/WORK/vue-diagram-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51477eda')) {
      api.createRecord('51477eda', component.options)
    } else {
      api.reload('51477eda', component.options)
    }
    module.hot.accept("./DiagramNodeTitle.vue?vue&type=template&id=51477eda&", function () {
      api.rerender('51477eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiagramNodeTitle.vue"
export default component.exports